export default function EngineInbox() {
  return <div>Inbox Page</div>;
}
